import { faDollar } from '@fortawesome/pro-solid-svg-icons';
import {
  HeroMetric,
  HeroMetricProps,
} from '../../../../../../components/Summary/HeroMetric';
import { useReturnOnAdSpend } from '@features/campaigns/hooks/useCalculatedFields';
import { useCurrentAdSpend } from '@features/campaigns/subdomains/visitation/hooks/useAdSpend';

type RoasHeroMetricProps = {
  metricProps: Omit<HeroMetricProps, 'value'>;
} & Omit<Parameters<typeof useReturnOnAdSpend>[0], 'adSpend'>;

export const RoasHeroMetric = (props: RoasHeroMetricProps) => {
  const { adSpend } = useCurrentAdSpend();
  const { value } = useReturnOnAdSpend({ ...props, adSpend });

  return <HeroMetric {...props.metricProps} value={value} icon={faDollar} />;
};
